import { FC } from "react";
import { Outlet } from "react-router-dom";

const Profile: FC = () => {
  return <Outlet />;
};

export default Profile;
